interface PageHeaderProps {
  heading: string;
  description: string;
}

function PageHeader({ heading, description }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="text-primary font-semibold text-lg md:text-xl lg:text-2xl">
        {heading}
      </h1>
      <p className="text-foreground/80 text-sm md:text-base lg:text-lg">
        {description}
      </p>
    </div>
  );
}

export { PageHeader };
